import { FC } from 'react';

export const TextHighlightIcon: FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M14.5 3.5L20 9L15.5 13.5L10 8L14.5 3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M10 8L7 11V14H10L13 11" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <line x1="4" y1="19" x2="20" y2="19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
